import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { MagnifyingGlassIcon, XIcon } from '@yonderland/andes-icons';
import { Icon, IconButton, TextField } from '@yonderland/andes-react';
import { useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FormField } from '../../form/FormField';
export const initialValuesContentOverviewForm = {
    contentSearch: '',
};
export const ContentOverviewForm = ({ initialValues, onSubmit, onSearchChange, handleResetValues, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const formProps = useForm({
        defaultValues: initialValues,
    });
    const contentSearch = formProps.watch('contentSearch');
    const prevContentRef = useRef(contentSearch);
    useEffect(() => {
        if (initialValues.contentSearch !== formProps.getValues('contentSearch')) {
            formProps.reset(initialValues);
            prevContentRef.current = initialValues.contentSearch;
        }
    }, [initialValues.contentSearch]);
    useEffect(() => {
        if (prevContentRef.current !== contentSearch) {
            onSearchChange(contentSearch);
        }
        prevContentRef.current = contentSearch;
    }, [contentSearch, onSearchChange]);
    return (_jsx(FormProvider, Object.assign({}, formProps, { children: _jsx("form", { onSubmit: formProps.handleSubmit(onSubmit), name: "content-overview-form", noValidate: true, children: _jsx(FormField, { name: "contentSearch", children: (_a) => {
                    var _b = _a.fieldProps, { ref, value } = _b, options = __rest(_b, ["ref", "value"]), { error } = _a;
                    return (_jsx(TextField, Object.assign({}, options, { innerRef: ref, value: value, id: "contentSearch", placeholder: t('flyout.search.placeholder'), error: error, adornmentEnd: _jsxs(_Fragment, { children: [value && !error && (_jsx(IconButton, { variant: "plain", size: "sm", onClick: e => {
                                        e.preventDefault();
                                        formProps.reset(initialValuesContentOverviewForm);
                                        handleResetValues();
                                    }, children: _jsx(Icon, { source: XIcon }) })), _jsx(IconButton, { type: "submit", variant: "plain", size: "sm", children: _jsx(Icon, { source: MagnifyingGlassIcon, color: !value || error ? 'subtle' : undefined }) })] }) })));
                } }) }) })));
};
